var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowPrevious(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9097 13.2606C14.8027 13.0204 14.7475 12.7605 14.7475 12.4976C14.7475 12.2348 14.8027 11.9749 14.9097 11.7347L18.2427 4.25191C19.1596 2.46097 17.2608 1.43098 16.1006 2.33204C13.9476 4.0041 8.4927 9.03625 6.02276 11.3325C5.86258 11.4814 5.73481 11.6617 5.64745 11.8621C5.56008 12.0626 5.51499 12.279 5.51499 12.4976C5.51499 12.7163 5.56008 12.9327 5.64745 13.1331C5.73481 13.3336 5.86258 13.5139 6.02276 13.6628C8.4927 15.959 13.9476 20.9912 16.1006 22.6632C17.2895 23.5866 19.1425 22.5009 18.2427 20.7434L14.9097 13.2606Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPrevious);
export default __webpack_public_path__ + "static/media/arrow-previous.23c59b1fb1489dfe2dd20b797ca69b09.svg";
export { ForwardRef as ReactComponent };